export const getNumberFromConfidence = (
    primitive: PreFilterPrimitive,
    defaultValue: number,
): number => {
    if (typeof primitive === 'string') {
        if (primitive === 'LOW') {
            return 0;
        }

        if (primitive === 'MEDIUM') {
            return 1;
        }

        if (primitive === 'HIGH') {
            return 2;
        }
    }

    return defaultValue;
};
